import Vue from 'vue'
import Vuex from 'vuex'
import auth from '../commons/auth/vuex-module'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth
  }
})
